import React from 'react';
import { bool, shape, string } from 'prop-types';

const ArrowDownColor = ({
  className = 'icon',
  notUseClass = false,
  style = { color: '#696f88' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.5575 6.22266L9 9.65766L12.4425 6.22266L13.5 7.28016L9 11.7802L4.5 7.28016L5.5575 6.22266Z" fill="currentColor" />
  </svg>
);

ArrowDownColor.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default ArrowDownColor;
